import React, { useState, useEffect, useCallback } from "react";
import { API, UPLOADS } from "./../../config/api";
import { useLocation } from "react-router-dom";
export default function Pendingmachine() {
  const location = useLocation();
  const [machines, setMachines] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [search, setSearch] = useState("");
  // const [statusFilter, setStatusFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState(
    location.state?.status || "All",
  );
  // Carousel states
  const [carouselOpen, setCarouselOpen] = useState(false);
  const [carouselImages, setCarouselImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 25;

  useEffect(() => {
    if (location.state?.status) {
      setStatusFilter(location.state.status);
    }
  }, [location.state]);
  const [renewModal, setRenewModal] = useState({
    open: false,
    machine: null,
    days: 30,
    amount: 0,
  });

  const openRenewModal = (machine) => {
    setRenewModal({
      open: true,
      machine,
      days: machine.show_ads_days || 30,
      amount: machine.ads_amount || 0,
    });
  };

  useEffect(() => {
    fetchMachines();
  }, [search, statusFilter]);

  const formatDate = (date) => {
    if (!date || date === "0000-00-00 00:00:00" || date === null) {
      return "-";
    }
    const d = new Date(date);
    if (isNaN(d.getTime())) {
      return "-";
    }
    return (
      <>
        <div className="fw-bold text-dark">{d.toLocaleDateString()}</div>
        <div className="text-muted small">
          {d.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>
      </>
    );
  };

  const renewMachineAdvertisement = async () => {
    try {
      const fd = new FormData();
      fd.append("id", renewModal.machine.id);
      fd.append("days", renewModal.days);
      fd.append("amount", renewModal.amount);

      const res = await fetch(
        `${API.BASE_URL}/api.php?action=renew_machine_ads`,
        {
          method: "POST",
          body: fd,
        },
      );
      const data = await res.json();
      alert(data.message);

      if (data.status) {
        setRenewModal({
          open: false,
          machine: null,
          days: 30,
          amount: 0,
        });
        fetchMachines();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchMachines = async () => {
    try {
      let url = `${API.BASE_URL}/api.php?action=list_machines_status`;
      if (statusFilter !== "All") {
        url += `&status=${statusFilter}`;
      }
      const res = await fetch(url);
      const data = await res.json();
      setMachines(data.data || []);
    } catch (error) {
      console.log("Fetch Error:", error);
    }
  };

  const handleView = (machine) => {
    setSelectedMachine(machine);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleStatus = async (status) => {
    if (status === "Rejected") {
      const confirmDelete = window.confirm(
        "Are you sure? Rejecting this machine will permanently delete it from the database and remove its images.",
      );
      if (!confirmDelete) return;
    }

    try {
      const formData = new FormData();
      formData.append("id", selectedMachine.id);

      if (status !== "Rejected") {
        formData.append("status", status); // Active or Hide
      }

      const apiUrl =
        status === "Rejected" ? API.DELETE_MACHINE : API.UPDATE_MACHINE_STATUS;

      const res = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      alert(data.message);

      setShowModal(false);
      fetchMachines();
    } catch (error) {
      console.log("Operation Error:", error);
    }
  };
  // Open Carousel for either the Payment Screenshot OR Product Gallery
  const openCarousel = (imgArray, startIndex = 0) => {
    setCarouselImages(imgArray);
    setCurrentImageIndex(startIndex);
    setCarouselOpen(true);
  };

  const nextSlide = useCallback(() => {
    setCurrentImageIndex((prev) => (prev + 1) % carouselImages.length);
  }, [carouselImages.length]);

  const prevSlide = useCallback(() => {
    setCurrentImageIndex(
      (prev) => (prev - 1 + carouselImages.length) % carouselImages.length,
    );
  }, [carouselImages.length]);

  // Handle arrow key presses for sliding images
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!carouselOpen) return;
      if (e.key === "ArrowRight") nextSlide();
      if (e.key === "ArrowLeft") prevSlide();
      if (e.key === "Escape") setCarouselOpen(false);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [carouselOpen, nextSlide, prevSlide]);

  const filteredMachines = machines.filter((item) => {
    const text = search.toLowerCase();
    return (
      item.name?.toLowerCase().includes(text) ||
      item.phone?.toString().includes(text) ||
      String(item.user_id).includes(text) ||
      item.machine_name?.toLowerCase().includes(text)
    );
  });
  const totalPages = Math.ceil(filteredMachines.length / recordsPerPage);

  const paginatedMachines = filteredMachines.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage,
  );

  const getPagination = () => {
    let pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      if (currentPage > 3) {
        pages.push("...");
      }

      let start = Math.max(2, currentPage - 1);
      let end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) {
        pages.push("...");
      }

      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className="dashboard-content">
      <style>{`
        /* UNIFIED FILTER AREA CSS */
        .filter-container {
          display: flex;
          align-items: center;
          gap: 16px;
          background-color: #ffffff;
          padding: 18px 20px;
          border-radius: 10px;
          margin-bottom: 24px;
          border: 1px solid #e9ecef;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
        }
        .filter-group-status {
          flex: 0 0 200px;
          display: flex;
          flex-direction: column;
        }
        .filter-group-search {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        .filter-label {
          font-size: 11px;
          font-weight: 700;
          color: #6c757d;
          margin-bottom: 6px;
          text-transform: uppercase;
          letter-spacing: 0.8px;
        }
        .filter-input {
          padding: 10px 14px;
          border: 1px solid #ced4da;
          border-radius: 8px;
          font-size: 14px;
          background-color: #fff;
          outline: none;
          transition: all 0.2s ease-in-out;
          color: #495057;
        }
        .filter-input:focus {
          border-color: #0d6efd;
          box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.15);
        }

        /* MODERN LIGHTWEIGHT TABLE STYLING */
        .table-responsive {
          background-color: #ffffff;
          border: 1px solid #eef2f5;
          border-radius: 12px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.02);
          overflow: hidden;
          margin-bottom: 30px;
        }
        .machine-table {
          width: 100%;
          border-collapse: collapse;
          text-align: left;
          font-size: 14px;
          color: #495057;
        }
        .machine-table th {
          background-color: #f8fafc;
          color: #627183;
          font-weight: 600;
          text-transform: uppercase;
          font-size: 11px;
          letter-spacing: 0.8px;
          padding: 14px 18px;
          border-bottom: 1px solid black;
        }
        .machine-table td {
          padding: 14px 18px;
          border-bottom: 1px solid #f1f5f9;
          vertical-align: middle;
          background-color: #ffffff;
        }
        .machine-table tbody tr:last-child td {
          border-bottom: none;
        }
        .machine-table tbody tr:hover td {
          background-color: #f8fafc;
        }
        
        /* Typography utilities inside table */
        .fw-bold { font-weight: 600; color: #1e293b; }
        .text-muted { color: #64748b; }
        .small { font-size: 12px; }

        /* BADGES STYLE (LIGHT MODE COLORS) */
        .status-badge {
          display: inline-flex;
          align-items: center;
          padding: 5px 10px;
          font-size: 12px;
          font-weight: 600;
          border-radius: 30px;
          text-transform: capitalize;
        }
        .status-badge.pending { background-color: #fff7ed; color: #c2410c; border: 1px solid #ffedd5; }
        .status-badge.active { background-color: #f0fdf4; color: #15803d; border: 1px solid #dcfce7; }
        .status-badge.hide { background-color: #fef2f2; color: #b91c1c; border: 1px solid #fee2e2; }
        .status-badge.expired { background-color: #fef2f2; color: #b91c1c; }
        .status-badge.running { background-color: #f0fdf4; color: #16a34a; }

        /* ACTION BUTTONS */
        .action-buttons {
          display: flex;
          gap: 8px;
          align-items: center;
        }
        .view-icon-btn, .renew-icon-btn {
          border: 1px solid #e2e8f0;
          background: #ffffff;
          padding: 7px 10px;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
        .view-icon-btn { color: #0a2446; }
        .view-icon-btn:hover { background-color: #e0e7ff; border-color: #c7d2fe; }
        .renew-icon-btn { color: #0ea5e9; }
        .renew-icon-btn:hover { background-color: #e0f2fe; border-color: #bae6fd; }

        @media (max-width: 768px) {
          .filter-container { flex-direction: column; align-items: stretch; gap: 12px; padding: 15px; }
          .filter-group-status { flex: 1 1 auto; }
        }

        /* Details Modal Container Styles */
        .popup-overlay {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          background-color: rgba(15, 23, 42, 0.75); backdrop-filter: blur(4px);
          z-index: 1050; display: flex; justify-content: center; align-items: center; padding: 20px;
        }
        .popup-box {
          background: #ffffff; border-radius: 16px; width: 100%; max-width: 800px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); display: flex;
          flex-direction: column; max-height: 90vh;  border: 1px solid #e2e8f0;
        }
        .popup-header { padding: 16px 24px; border-bottom: 1px solid #f1f5f9; background: #fafafa; }
        .popup-header h3 { margin: 0; font-size: 1.25rem; color: #1e293b; font-weight: 600; }
      
        .description-box { padding: 0 24px; margin-bottom: 12px; }
        .description-box p { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 8px 12px; max-height: 60px; overflow-y: auto; font-size: 0.85rem; }
        .media-footer-row { display: flex; gap: 20px; padding: 0 24px; margin-bottom: 16px; align-items: center; }
        .payment-proof-section { flex: 1; }
        .payment-thumbnail-wrapper { border: 1px dashed #cbd5e1; border-radius: 8px; padding: 4px; display: inline-block; cursor: pointer; transition: border-color 0.2s; }
        .payment-thumbnail-wrapper:hover { border-color: #3b82f6; }
        .payment-thumbnail-wrapper img { height: 50px; width: 80px; object-fit: contain; border-radius: 4px; }
        .machine-gallery-section { flex: 2; }
       
        .popup-images img:hover { transform: scale(1.08); border-color: #3b82f6; }
        .modal-actions { padding: 16px 24px; border-top: 1px solid #f1f5f9; background: #f8fafc; display: flex; justify-content: flex-end; gap: 10px; }
        .btn { padding: 8px 16px; border-radius: 8px; font-weight: 500; font-size: 0.875rem; display: flex; align-items: center; gap: 6px; border: 1px solid transparent;}
        .btn-success { background: #22c55e; color: white; }
        .btn-warning { background: #eab308; color: white; }
        .btn-info { background: #06b6d4; color: white; }
        .btn-danger { background: #ef4444; color: white; }
        .btn-secondary { background: #64748b; color: white; }
        
        /* LIGHTBOX SLIDER */
        .lightbox-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(15, 23, 42, 0.95); z-index: 2000; display: flex; justify-content: center; align-items: center; }
        .lightbox-content { position: relative; width: 90vw; height: 80vh; display: flex; justify-content: center; align-items: center; }
        .lightbox-image { max-width: 100%; max-height: 100%; object-fit: contain; border-radius: 8px; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5); user-select: none; }
        .lightbox-btn { position: absolute; background: rgba(255, 255, 255, 0.1); color: white; border: none; width: 48px; height: 48px; border-radius: 50%; font-size: 24px; cursor: pointer; display: flex; justify-content: center; align-items: center; transition: background 0.2s; }
        .lightbox-btn:hover { background: rgba(255, 255, 255, 0.25); }
        .lightbox-prev { left: 20px; }
        .lightbox-next { right: 20px; }
        .lightbox-close { top: -20px; right: 10px; background: #ef4444; width: 40px; height: 40px; }
        .lightbox-counter { position: absolute; bottom: -40px; color: #94a3b8; font-size: 0.9rem; font-weight: 500; }
        
        /* RENEW MODAL CSS */
        .renewads-popup-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(15, 23, 42, 0.5); z-index: 1050; display: flex; justify-content: center; align-items: center; }
        .renewads-popup-box { background: white; padding: 24px; border-radius: 12px; width: 100%; max-width: 400px; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1); }
        .renewads-title { margin-top: 0; margin-bottom: 16px; font-size: 1.15rem; color: #1e293b; }
        .renewads-body { margin-bottom: 12px; display: flex; flex-direction: column; }
        .renewads-body label { font-size: 12px; font-weight: 600; color: #64748b; margin-bottom: 4px; }
        .renewads-input { padding: 8px 12px; border: 1px solid #cbd5e1; border-radius: 6px; outline: none; }
        .renewads-footer { display: flex; justify-content: flex-end; gap: 8px; margin-top: 20px; }
      
    
      `}</style>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "15px",
        }}
      >
        <h2 className="machine-title">{statusFilter} Machine Requests</h2>
      </div>

      {/* FILTERS */}
      <div className="filter-container">
        <div className="filter-group-status">
          <label className="filter-label">Filter Status</label>
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="filter-input"
          >
            <option value="All">All Requests</option>
            <option value="Pending">Pending</option>
            <option value="Active">Active</option>
            <option value="Hide">Hide</option>
          </select>
        </div>

        <div className="filter-group-search">
          <label className="filter-label">Search Machine</label>
          <input
            type="text"
            className="filter-input"
            placeholder="Search by Name, Mobile, User ID, or Machine Name..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {/* UPDATED TABLE AREA */}
      <div className="table-responsive">
        <table className="machine-table">
          <thead>
            <tr>
              <th>#</th>
              <th>U_Id</th>
              <th>Date</th>
              <th>Seller</th>
              <th>Ads Info</th>
              <th>Active Date</th>
              <th>End Date</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredMachines.length > 0 ? (
              paginatedMachines.map((item, index) => (
                <tr key={item.id}>
                  <td>
                    {filteredMachines.length -
                      ((currentPage - 1) * recordsPerPage + index)}
                  </td>

                  <td className="fw-bold">{item.user_id}</td>
                  <td>
                    <div className="fw-bold">
                      {new Date(item.created_at).toLocaleDateString()}
                    </div>
                    <div className="text-muted small">
                      {new Date(item.created_at).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </td>
                  <td>
                    <div className="fw-bold">{item.name}</div>
                    <div className="text-muted small">{item.phone}</div>
                  </td>
                  <td>
                    <div className="fw-bold">{item.show_ads_days} Days</div>
                    <div className="text-muted small">₹{item.ads_amount}</div>
                    {(() => {
                      if (!item.ads_start_date || !item.ads_end_date) {
                        return (
                          <span
                            className="status-badge pending"
                            style={{
                              marginTop: 4,
                              display: "inline-block",
                              fontSize: "10px",
                              padding: "2px 6px",
                            }}
                          >
                            Pending
                          </span>
                        );
                      }
                      const isExpired =
                        new Date(item.ads_end_date) < new Date();
                      return (
                        <span
                          className={`status-badge ${isExpired ? "hide" : "active"}`}
                          style={{
                            marginTop: 4,
                            display: "inline-block",
                            fontSize: "10px",
                            padding: "2px 6px",
                          }}
                        >
                          {isExpired ? "Expired" : "Running"}
                        </span>
                      );
                    })()}
                  </td>
                  <td>{formatDate(item.ads_start_date)}</td>
                  {/* <td>{formatDate(item.ads_end_date)}</td> */}
                  <td>
                    {item.status === "Pending"
                      ? "-"
                      : formatDate(item.ads_end_date)}
                  </td>
                  <td>
                    <span
                      className={`status-badge ${
                        item.status === "Pending"
                          ? "pending"
                          : item.status === "Active"
                            ? "active"
                            : "hide"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>
                  <td>
                    {(() => {
                      const isExpired =
                        item.ads_end_date &&
                        new Date(item.ads_end_date) < new Date();
                      return (
                        <div className="action-buttons">
                          {item.status === "Pending" &&
                            Number(item.machine_free_plan_used) === 1 && (
                              <button
                                className="renew-icon-btn"
                                onClick={() => openRenewModal(item)}
                                title="Renew Ads"
                              >
                                <i className="bi bi-arrow-repeat"></i>
                              </button>
                            )}
                          {item.status === "Hide" && isExpired && (
                            <button
                              className="renew-icon-btn"
                              onClick={() => openRenewModal(item)}
                              title="Renew Ads"
                            >
                              <i className="bi bi-arrow-repeat"></i>
                            </button>
                          )}
                          <button
                            className="view-icon-btn"
                            onClick={() => handleView(item)}
                            title="View Details"
                          >
                            <i className="bi bi-eye-fill"></i>
                          </button>
                        </div>
                      );
                    })()}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="9"
                  style={{
                    textAlign: "center",
                    padding: "24px",
                    color: "#64748b",
                  }}
                >
                  No matching machine requests found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            marginTop: "20px",
          }}
        >
          <button
            className="btn btn-secondary"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            Previous
          </button>

          {getPagination().map((page, index) =>
            page === "..." ? (
              <span key={index} style={{ padding: "8px 12px" }}>
                ...
              </span>
            ) : (
              <button
                key={index}
                className="btn"
                style={{
                  background: currentPage === page ? "#0d6efd" : "#e9ecef",
                  color: currentPage === page ? "#fff" : "#000",
                }}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            ),
          )}

          <button
            className="btn btn-secondary"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            Next
          </button>
        </div>
      </div>

      {/* POPUP MODAL */}
      {showModal && selectedMachine && (
        <div className="popup-overlay" onClick={handleClose}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <h3>⚙ Machine Request Details</h3>
            </div>

            <div className="popup-grid">
              <div>
                <label>Machine Type</label>
                <p>{selectedMachine.machine_name || "-"}</p>
              </div>
              <div>
                <label>Left Side Head Type</label>
                <p>{selectedMachine.left_head_type || "-"}</p>
              </div>
              <div>
                <label>Right Side Head Type</label>
                <p>{selectedMachine.right_head_type || "-"}</p>
              </div>
              <div>
                <label>Brand</label>
                <p>{selectedMachine.brand || "-"}</p>
              </div>
              <div>
                <label>Model</label>
                <p>{selectedMachine.model || "-"}</p>
              </div>
              <div>
                <label>No Of Heads</label>
                <p>{selectedMachine.NoOfHeads || "-"}</p>
              </div>
              <div>
                <label>No Of Needles</label>
                <p>{selectedMachine.NoOfNeedls || "-"}</p>
              </div>
              <div>
                <label>Max Sewing Speed(RPM)</label>
                <p>{selectedMachine.Maxsewingspeed || "-"}</p>
              </div>
              <div>
                <label>Beam Body Size (MM)</label>
                <p>{selectedMachine.beamBody || "-"}</p>
              </div>
              <div>
                <label>Motor</label>
                <p>{selectedMachine.motor || "-"}</p>
              </div>
              <div>
                <label>Usb Port</label>
                <p>{selectedMachine.usbport || "-"}</p>
              </div>
              <div>
                <label>Machine Age</label>
                <p>{selectedMachine.machine_old || "-"}</p>
              </div>
              <div>
                <label>Price</label>
                <p>₹ {selectedMachine.price || "-"}</p>
              </div>
              <div>
                <label>Status</label>
                <p>{selectedMachine.status || "-"}</p>
              </div>
              <div>
                <label>City</label>
                <p>{selectedMachine.city || "-"}</p>
              </div>
              <div>
                <label>Seller</label>
                <p>
                  {selectedMachine.name} ({selectedMachine.phone})
                </p>
              </div>
              <div>
                <label>Location</label>
                <p>
                  {selectedMachine.location}, {selectedMachine.city},{" "}
                  {selectedMachine.state}
                </p>
              </div>
              <div>
                <label>Ads Duration</label>
                <p>{selectedMachine.show_ads_days} Days</p>
              </div>
            </div>

            {selectedMachine.description && (
              <div className="description-box">
                <label>Description</label>
                <p>{selectedMachine.description}</p>
              </div>
            )}

            {/* Media Gallery */}

            {selectedMachine.payment_screenshot && (
              <div className="payment-proof-section">
                <div
                  className="payment-thumbnail-wrapper"
                  onClick={() => {
                    const payUrl = `${UPLOADS.MACHINE_IMAGE}${selectedMachine.user_id}/payment/${selectedMachine.payment_screenshot}`;
                    openCarousel([payUrl], 0);
                  }}
                >
                  <img
                    src={`${UPLOADS.MACHINE_IMAGE}${selectedMachine.user_id}/payment/${selectedMachine.payment_screenshot}`}
                    alt="payment thumb"
                  />
                </div>
              </div>
            )}

            {selectedMachine.image && (
              <div className="popup-images">
                {selectedMachine.image.split(",").map((img, i) => {
                  const imgUrl = `${UPLOADS.MACHINE_IMAGE}${selectedMachine.user_id}/${img}`;
                  const allImages = selectedMachine.image
                    .split(",")
                    .map(
                      (imageFilename) =>
                        `${UPLOADS.MACHINE_IMAGE}${selectedMachine.user_id}/${imageFilename}`,
                    );
                  return (
                    <img
                      key={i}
                      src={`${imgUrl}?t=${Date.now()}`}
                      alt={`preview-${i}`}
                      onClick={() => openCarousel(allImages, i)}
                    />
                  );
                })}
              </div>
            )}

            {/* Actions Panel */}
            <div className="modal-actions">
              {selectedMachine.status === "Active" ||
              selectedMachine.status === "Hide" ? (
                ""
              ) : (
                <button
                  className="btn btn-success"
                  onClick={() => handleStatus("Active")}
                >
                  <i className="bi bi-check-lg"></i> Accept
                </button>
              )}

              {selectedMachine.status !== "Hide" ? (
                <button
                  className="btn btn-warning"
                  onClick={() => handleStatus("Hide")}
                >
                  <i className="bi bi-eye-slash"></i> Hide
                </button>
              ) : (
                <button
                  className="btn btn-info"
                  onClick={() => handleStatus("Active")}
                >
                  <i className="bi bi-eye"></i> Unhide
                </button>
              )}
              <button
                className="btn btn-danger"
                onClick={() => handleStatus("Rejected")}
              >
                <i className="bi bi-trash"></i> Reject & Delete
              </button>
              <button className="btn btn-secondary" onClick={handleClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* LIGHTBOX SLIDER */}
      {carouselOpen && carouselImages.length > 0 && (
        <div
          className="lightbox-overlay"
          onClick={() => setCarouselOpen(false)}
        >
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="lightbox-btn lightbox-close"
              onClick={() => setCarouselOpen(false)}
            >
              ×
            </button>

            {carouselImages.length > 1 && (
              <button
                className="lightbox-btn lightbox-prev"
                onClick={prevSlide}
              >
                ‹
              </button>
            )}

            <img
              src={carouselImages[currentImageIndex]}
              alt="Viewing Fullscreen"
              className="lightbox-image"
            />

            {carouselImages.length > 1 && (
              <button
                className="lightbox-btn lightbox-next"
                onClick={nextSlide}
              >
                ›
              </button>
            )}

            <div className="lightbox-counter">
              Image {currentImageIndex + 1} of {carouselImages.length}
            </div>
          </div>
        </div>
      )}

      {/* RENEW ADS MODAL */}
      {renewModal.open && (
        <div
          className="renewads-popup-overlay"
          onClick={() => setRenewModal({ ...renewModal, open: false })}
        >
          <div
            className="renewads-popup-box"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="renewads-title">Renew Machine Advertisement</h3>
            <div className="renewads-body">
              <label>Renew Days</label>
              <input
                type="number"
                min="1"
                className="renewads-input"
                value={renewModal.days}
                onChange={(e) =>
                  setRenewModal({ ...renewModal, days: e.target.value })
                }
              />
            </div>
            <div className="renewads-body">
              <label> Amount</label>
              <input
                type="number"
                min="0"
                className="renewads-input"
                value={renewModal.amount}
                onChange={(e) =>
                  setRenewModal({ ...renewModal, amount: e.target.value })
                }
              />
            </div>
            <div className="renewads-footer">
              <button
                className="renewads-btn renewads-save"
                onClick={renewMachineAdvertisement}
              >
                Renew
              </button>
              <button
                className="renewads-btn renewads-cancel"
                onClick={() => setRenewModal({ ...renewModal, open: false })}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
